(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    (() => {
      const gate = document.querySelector('[data-age-gate]');
      if (!gate) return;
      const storageKey = 'weber_age_verified_until';
      const now = Date.now();
      let verifiedUntil = 0;
      try { verifiedUntil = Number(window.localStorage.getItem(storageKey) || 0); } catch (error) { verifiedUntil = 0; }
      if (verifiedUntil > now) return;
      gate.hidden = false;
      document.documentElement.classList.add('weber-age-gate-open');
      const confirmButton = gate.querySelector('[data-age-confirm]');
      confirmButton?.focus();
      confirmButton?.addEventListener('click', () => {
        const thirtyDays = 30 * 24 * 60 * 60 * 1000;
        try { window.localStorage.setItem(storageKey, String(Date.now() + thirtyDays)); } catch (error) {}
        gate.hidden = true;
        document.documentElement.classList.remove('weber-age-gate-open');
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
